import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  LinearProgress,
  Table,
  TableCell,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";
import { HOST_API } from "src/config-prod";
import { useEffect, useRef, useState } from "react";
import { usePDF, Resolution } from "react-to-pdf";
import { orderslabel } from "../api";
import { useSnackbar } from "notistack";
import { useReactToPrint } from "react-to-print";
import "./style.css";
import Barcode from "react-barcode";

// Component to generate and print shipping labels
const GenerateLabel = ({ onClose, data }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [labelData, setData] = useState([]);
  const [vendorDetails, setVendorDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const componentref = useRef();

    // Function to fetch label details for the selected orders
    const fetchLabel = (labelId) => {
      if (labelId) {
        setLoading(true);
        const orderId = labelId.map((el) => el?.original?.orderID).join(",");
        const req = { orderIDs: orderId };
        orderslabel(req)
          .then((data) => {
            if (data.length > 0) {
              const extractedVendorDetails = data.find((item) => item.vendorDetails)?.vendorDetails;
              setVendorDetails(extractedVendorDetails);
              setData(data.filter((item) => item.orderID));
              setLoading(false);
              return;
            }
            setLoading(false);
            enqueueSnackbar("Label details not present for provided order ID", {
              variant: "error",
            });
          })
          .catch((error) => {
            console.log(error);
            enqueueSnackbar("Something Went Wrong", { variant: "error" });
            setLoading(false);
          });
      }
    };

    // Fetch labels when component mounts
  useEffect(() => {
    fetchLabel(data);
  }, [data]);

    // Generate PDF from labels
  const { toPDF, targetRef } = usePDF({
    method: "save",
    filename: `label-${new Date().toDateString()}`,
    page: {
      margin: { top: 10, right: 7, bottom: 17, left: 7 },
      format: [230, 240],
    },
    resolution: Resolution.LOW,
  });

    // Print labels using React-to-Print
  const handlePrint = useReactToPrint({
    content: () => targetRef.current,
    copyStyles: true,
    // pageStyle:
  });

  return (
    <Dialog fullScreen open onClose={onClose}>
      {/* AppBar for the dialog header */}
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Download Label
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            &times;
          </IconButton>
        </Toolbar>
      </AppBar>
      {loading && <LinearProgress />}
      <DialogContent
        ref={componentref}
        sx={{ width: "1536px;", paddingTop: 0 }}
      >
        <Grid container spacing={2} ref={targetRef}>
          {labelData &&
            labelData.map(item => (
              <Grid item xs={6} key={item}>
                <Table
                  sx={{
                    height: "717px",
                    border: theme => `2px solid ${theme.palette.grey[900]}`,
                    "& .MuiTableCell-root": {
                      border: theme => `2px solid ${theme.palette.grey[900]}`,
                      padding: "0px 2px 10px 4px",
                    },
                  }}
                >
                   {/* Header section with logo and shipping type */}
                  <TableRow sx={{ height: "100px" }}>
                    <TableCell sx={{ width: 260 }} align="center">
                    {vendorDetails?.image && (
                      <img
                        src={`${HOST_API}images/product/${vendorDetails.image}`}
                        alt="Vendor Logo"
                        style={{ width: 90, margin: "auto" }}
                      />
                    )}
                    {/* <Typography variant="h6">{vendorDetails?.companyName || "Vendor"}</Typography> */}
                    </TableCell>
                    <TableCell colSpan={2} align="center">
                      <Typography variant="h6">{item?.shippingType}</Typography>
                    </TableCell>
                    <TableCell colSpan={2} align="center">
                      <Typography variant="h6">Online</Typography>

                      {item?.totalAmount || 0}
                    </TableCell>
                  </TableRow>

                   {/* Product details section */}
                  <TableRow>
                    <TableCell>
                      <Typography variant="h6">Product Name</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography variant="h6">Price</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="h6">Qty</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="h6">Total</Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Typography variant="body1">
                        {item?.packageName || ""}
                      </Typography>
                    </TableCell>

                    <TableCell>
                      <Typography variant="body1">
                        {item?.totalPrice}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body1">1</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body1">
                        {item?.totalPrice}
                      </Typography>
                    </TableCell>
                  </TableRow>

                  {/* Address details section */}
                  <TableRow>
                    <TableCell colSpan={4}>
                      <div style={{ height: "50px" }}>
                        <Typography variant="body1">
                          <b>Note</b> - No Open Delivery Allowed
                        </Typography>
                        <Typography variant="body1">
                          <b>OrderId:</b> {item?.orderID}
                        </Typography>
                      </div>
                    </TableCell>
                    {/* <TableCell colSpan={3}>
                      <Typography variant="body1">
                        <b>Package Weight & Dim</b>
                      </Typography>
                    </TableCell> */}
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2}>
                      <div style={{ height: "220px" }}>
                        <Typography variant="h5">
                          <b>
                            To : {item.parentFirstName || ""}
                            {item?.parentLastName || ""}
                          </b>{" "}
                        </Typography>

                        <Typography variant="h5">
                          {item?.address1 || ""},{item?.address2 || ""}{" "}
                          {item?.city || ""} {item?.stateName || ""},
                          {item?.pin || ""}
                        </Typography>

                        <Typography variant="h5">
                          {" "}
                          <b>contact:</b>
                          {item?.mobile || ""}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell colSpan={3} align="center">
                      <Typography variant="h6">
                        <b>
                          {item?.stateName}
                          <br />
                          {item?.pin}
                        </b>
                      </Typography>
                    </TableCell>
                  </TableRow>

                  {/* Barcode section */}
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <div style={{ height: "100px" }}>
                        <Barcode
                          value={item?.orderID}
                          format="CODE128"
                          height={75}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell colSpan={5}>
                      <div style={{ height: "90px" }}>
                        <Typography variant="subtitle1">
                          if Not delivered Please returned at below address
                        </Typography>
                        <Typography variant="subtitle1">
                          Indian Corporation, Mankoli Naka, Bhiwandi 421302
                        </Typography>
                        <Typography variant="subtitle1">
                          {" "}
                          <b>GST No. 12547821475532</b>
                        </Typography>
                        <Typography variant="subtitle1">
                          <b>Ph:</b> 8828811288
                        </Typography>
                      </div>
                      <Typography variant="body1">
                        Subjected to Respective Courier Partner Conditions of
                        Carriage,which limit the liability of ShipYaari &
                        Courier Company for loss/delay/damage to the consignment
                      </Typography>
                      <Typography variant="body1">
                        <b>Powered By ShipYaari</b>
                      </Typography>
                    </TableCell>
                  </TableRow> */}
                </Table>
              </Grid>
            ))}
        </Grid>
      </DialogContent>

      {/* Actions for PDF and Print */}
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button
          onClick={toPDF}
          disabled={loading || !labelData.length}
          variant="contained"
          color="primary"
        >
          Export to PDF
        </Button>
        <Button
          onClick={handlePrint}
          disabled={loading || !labelData.length}
          variant="contained"
          color="error"
        >
          Print
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default GenerateLabel;
